// extracted by mini-css-extract-plugin
module.exports = {"button":"DefaultButton_button__2H6p2"};